import i18n from "../../Helpers/i18n";
import React, { useContext } from "react";
import PropTypes from "prop-types";
import Popup from "~/assets/js/components/Popup";
import Timeslot from "~/assets/js/components/Timeslot";
import { formatDate } from "~/assets/js/pages/Checkout/sections/TimeSlotSelect/formatDateTime";
import {
    ACTIONS,
    CheckoutContext,
} from "../../pages/Checkout/CheckoutProvider";
import Button from "~/assets/js/components/Button";
import useAreaCookie from "~/assets/js/Helpers/hooks/useAreaCookie";
import isEmpty from "lodash.isempty";
import CheckoutSession from "../../pages/Checkout/CheckoutSession";

const StoreHintPopup = ({
    storeStatus,
    open,
    handleClose,
    firstDeliveryTime,
}) => {
    let popupConfig = {};
    const currentDay = formatDate(firstDeliveryTime.deliveryDay).append;
    const cookie = useAreaCookie();
    const isDelivery = cookie && cookie?.area?.type === "delivery";

    switch (storeStatus) {
        case "closed":
            popupConfig = {
                title: i18n.t("storeHint.popupClosed.title"),
                subtitle: i18n.t("storeHint.popupClosed.subtitle"),
                handleClose: handleClose,
                open: open,
                isClosable: true,
                isInfo: true,
                customStyle: "store_hint_popup_closed",
            };
            break;
        case "opening_soon":
            popupConfig = {
                title: i18n.t("storeHint.popupOpeningSoon.title"),
                subtitle: i18n.t("storeHint.popupOpeningSoon.subtitle"),
                handleClose: handleClose,
                open: open,
                isClosable: true,
                isInfo: true,
                customStyle: "store_hint_popup_opening_soon",
            };
            break;
    }

    const generatePopupContent = () => {
        switch (storeStatus) {
            case "closed":
                return i18n.t("storeHint.popupClosed.content");
            case "opening_soon":
                return i18n.t("storeHint.popupOpeningSoon.content");
        }
    };

    const generateTimeSlotContent = () => {
        switch (storeStatus) {
            case "closed":
                return i18n.t("timeSlotSelect.firstAvailableDelivery");
            case "opening_soon":
                return isDelivery
                    ? i18n.t("timeSlotSelect.firstAvailableDeliveryOpeningSoon")
                    : i18n.t("timeSlotSelect.firstAvailablePickupOpeningSoon");
        }
    };

    const context = useContext(CheckoutContext);

    const handleSave = () => {
        if (!isEmpty(context)) {
            context.dispatch({
                type: ACTIONS.ADD_TIME_SLOT,
                payload: firstDeliveryTime,
            });
        } else {
            handleAdjustCheckoutSession();
        }

        handleClose();
    };

    /**
     * Adjusts checkout state for timeslots
     * outside checkout context
     */
    const handleAdjustCheckoutSession = () => {
        const session = CheckoutSession.init(CheckoutSession.initialState);
        session.timeSlot = firstDeliveryTime;
        CheckoutSession.update(session);
    };

    return (
        <Popup {...popupConfig}>
            <p className="store_hint_popup__content">
                {generatePopupContent()}
            </p>
            <Timeslot
                time={firstDeliveryTime}
                isFirst={true}
                isFirstContent={generateTimeSlotContent()}
                onValueChange={handleSave}
                append={currentDay}
            />
            <Button
                size="SM"
                variant="secondary"
                customStyle="early-on-location__button"
                onClick={handleClose}
                label={i18n.t("timeSlotSelect.earlyOnSite.info.close")}
            />
        </Popup>
    );
};

StoreHintPopup.propTypes = {
    storeStatus: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    firstDeliveryTime: PropTypes.object.isRequired,
};
export default StoreHintPopup;
